import { render } from "./RadioButtonComponent.vue?vue&type=template&id=0d18e012&ts=true"
import script from "./RadioButtonComponent.vue?vue&type=script&lang=ts"
export * from "./RadioButtonComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__